<div class="row clearfix">
  @for (a of mapData; track a) {
  @if (result) {
  <div [hidden]="a?.invisible"
    class="col-{{a.col? a.col : '6'}} text-left {{direction=='HORIZONTAL' ? 'horiz' : 'vertical'}}">
    <label class=" text-nowrap fw-bold">{{a.title}} :</label>
    @if (checkModify(a.name,a.type); as val) {
    @switch (a.type) {
    @case ('DATE') {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''" [innerHTML]="val.oldValue | dateFormat: 'dd-MM-yyyy'"></span>
      @if (val.newValue) {
      <mark> {{val.newValue | dateFormat:'dd-MM-yyyy'}}</mark>
      }
    </p>
    }
    @case ('CURRENCY') {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''" [innerHTML]="+val.oldValue | currencyFormat"></span>
      @if (val.newValue) {
      <mark>{{+val.newValue | currencyFormat}}</mark>
      }
    </p>
    }
    @case ('BOOLEAN') {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''" [innerHTML]="+val.oldValue ? 'YES' : 'NO'"></span>
      @if (val.newValue) {
      <mark>{{+val.newValue ? 'YES' : 'NO'}}</mark>
      }
    </p>
    }
    @case ('FILE') {
    <div class="imagediv">
      <image-doc-grid [src]="val?.newValue  || result[a.name + '_path']" [showDelete]="false"></image-doc-grid>
      @if (val.newValue) {
      <mark class="text-small">New Image</mark>
      }
    </div>
    }
    @default {
    @if (a.isClickable) {
    <p>
      <strong><a title="Info" (click)="openInfo(a.viewType,result[a.name])" href="javascript:void(0)">{{result[a.name]
          }}</a></strong>
    </p>
    }
    @if (!a.isClickable) {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''" [innerHTML]="val.oldValue"></span>
      @if (val.newValue) {
      <mark>{{val.newValue}}</mark>
      }
    </p>
    }
    }
    }
    }
  </div>
  }
  }
</div>